import React from 'react'
import * as statusModel from '../../../shared/routes/statusRoutes'
import { useModel } from '@stem-sims/nexus';
import Modal from 'react-bootstrap/Modal'
import { toast } from 'react-toastify';
import { useRoster } from './StudentsContext';
import { ProgramsType } from '../../../shared/types/studentTypes';
import DefaultImportForm from './ImportModals/Default';
import EthnicityForm from './ImportModals/Ethnicity';
import EnrollmentForm from './ImportModals/Enrollment';
import IEPForm from './ImportModals/IEP';
import ELLForm from './ImportModals/ELL';

type ImportProps = {
    show: boolean
    orgId: string
}

function Import(props: ImportProps) {
    const roster = useRoster()
    return (<>
        <Modal show={props.show} onHide={roster.hideModals} size={"xl"} className="student-modal">
            <ImportForm orgId={props.orgId} />
        </Modal>
    </>)
}

export type ModalType = "default" | "ethnicity" | "enrollment" | "iep" | "ell"

function ImportForm({ orgId }: { orgId: string }) {
    const roster = useRoster()
    const { response: status, loading: statusLoading } = useModel({
        model: statusModel.get
    })

    const disabledPrograms: ProgramsType[] = []
    const defaultProgramsSelected: ProgramsType[] = []

    const [modalType, setModalType] = React.useState<ModalType>("default")

    if (!statusLoading) {
        if (status.math.available === 0) {
            disabledPrograms.push("Math")
        }
        if (status.reading.available === 0) {
            disabledPrograms.push("Reading")
        }
        if (status.emergentReader.available === 0) {
            disabledPrograms.push("Emergent Reader")
        }

        if (disabledPrograms.includes("Math") && disabledPrograms.includes("Emergent Reader")) {
            defaultProgramsSelected.push("Reading")
        } else if (disabledPrograms.includes("Reading") && disabledPrograms.includes("Emergent Reader")) {
            defaultProgramsSelected.push("Math")
        } else if (disabledPrograms.includes("Math") && disabledPrograms.includes("Reading")) {
            defaultProgramsSelected.push("Emergent Reader")
        }

        if (disabledPrograms.length === 3) {
            toast.error("There aren't enough licenses to add a student")
            roster.refreshStudents()
            roster.hideModals()
        }
    }
    return <>
        <Modal.Header closeButton>
            <h2>Import Students from CSV</h2>
        </Modal.Header>

            {modalType === "default" && <DefaultImportForm setModalType={setModalType} />}

            {modalType === "ethnicity" && <EthnicityForm setModalType={setModalType} />}

            {modalType === "enrollment" && <EnrollmentForm setModalType={setModalType} />}

            {modalType === "iep" && <IEPForm setModalType={setModalType} />}

            {modalType === "ell" && <ELLForm setModalType={setModalType} />}
    </>
}

export default Import
